import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'
import Typography from '@material-ui/core/Typography'
import GoogleButton from 'react-google-button'
import { makeStyles } from '@material-ui/core/styles'

import appsumoActions from 'store/modules/appsumo'
import appsumoSelectors from 'store/selectors/appsumo'
import networkSelectors from '@nocode-works/template/store/selectors/network'

import {
  LOGIN_REDIRECT_URL,
  GOOGLE_LOGIN,
} from 'settings'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
  },
  paddedRow: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  googleButton: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  }
}))

const ActivateSuccess = ({
  classes,
}) => {

  const email = useSelector(appsumoSelectors.email)
  const plan = useSelector(appsumoSelectors.plan)

  const onLogin = () => {
    document.location = GOOGLE_LOGIN
  }

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Welcome Sumo-ling!
      </Typography>
      <Typography gutterBottom variant="body1">
        We just need to get your account setup and then we can begin making amazing websites!
      </Typography>
      <Typography gutterBottom variant="body1">
        Your AppSumo email address is shown below:
      </Typography>
      <div className={ classes.paddedRow }>
        <Alert severity="info">{ email }</Alert>
      </div>
      <Typography gutterBottom variant="body1">
        You will need a Google account to use nocode - you have two options here, both will work with your AppSumo lifetime license:
      </Typography>
      <ul>
        <li>
          <Typography gutterBottom variant="body1">
            Use an existing Google account to login to nocode.
          </Typography>
        </li>
        <li>
          <Typography gutterBottom variant="body1">
            Create a new Google account to login to nocode.
          </Typography>
        </li>
      </ul>
      <Typography gutterBottom variant="body1">
        Once you have logged in, your AppSumo account will automatically be 
        linked to your Google account and your lifetime AppSumo license will activate!
      </Typography>
      <div className={ classes.paddedRow }>

        
        <Grid container spacing={ 2 }>
          <Grid item xs={ 6 }>
            
            <Typography gutterBottom variant="h6">
              REALLY IMPORTANT!!!
            </Typography>
            <Typography gutterBottom variant="body1">
              Once you click the "Sign in with Google" button below - please tick the "See, edit, create and delete only the specific Google Drive files that you use with this app." option.
            </Typography>
            <Typography gutterBottom variant="body1">
              We need those permissions to create the folders and Docs that will make up your site.
            </Typography>

            <div className={ classes.googleButton }>
              <GoogleButton
                type="dark"
                onClick={ onLogin }
              />
            </div>
          </Grid>
          <Grid item xs={ 6 }>
            
            <img src="/img/permissions-box.png"/>
          </Grid>
        </Grid>
      </div>

    </>
  )
}

const ActivateError = ({
  classes,
  error,
}) => {
  return (
    <>
      <Typography variant="h4" color="error" gutterBottom>Activation Error</Typography>
      <Typography gutterBottom>Unfortunately there has been an error with your AppSumo License.</Typography>
      <Typography gutterBottom>Please email us at <b>support@nocode.works</b> or raise a support ticket from your AppSumo account.</Typography>
      <Typography gutterBottom>The error is shown below:</Typography>
      <div className={ classes.paddedRow }>
        <Alert severity="error">{ error }</Alert>
      </div>
    </>
  )
}

const Activate = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [ loaded, setLoaded ] = useState(false)
  const activateError = useSelector(state => {
    if(!state.network || !state.network.errors) return ''
    return state.network.errors['appsumo/activate']
  })

  const isActive = useSelector(appsumoSelectors.isActive)
  
  useEffect(() => {    
    const doAsync = async () => {
      await dispatch(appsumoActions.activate()) 
      setLoaded(true)
    }
    doAsync()
  }, [])

  if(!loaded) return null

  return (
    <div className={ classes.root }>
      <Container maxWidth="md">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper className={ classes.paper }>
              {
                isActive && (
                  <ActivateSuccess
                    classes={ classes }
                  />
                )
              }
              {
                activateError && (
                  <ActivateError
                    classes={ classes }
                    error={ activateError }
                  />
                )
              }
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default Activate